module.exports = __webpack_public_path__ + "img/northstar-3.d80817b5.jpg";